import ConfirmDialog from "../components/confirm-dialog";
import { useSuretyModel } from "../store/use-surety-popup";

interface TPopupSuretyModel {
  loading?: boolean;
}

const PopupSuretyModel = ({ loading = false }: TPopupSuretyModel) => {
  const { onCloseSuretyPopup, initialValues } = useSuretyModel();

  return (
    <ConfirmDialog
      title={initialValues?.title || "Are you sure you want to continue?"}
      description={initialValues?.description}
      confirmLabel={initialValues?.confirmLabel || "Confirm"}
      tone={initialValues?.tone}
      loading={loading}
      onConfirm={initialValues.onClick}
      onCancel={onCloseSuretyPopup}
    />
  );
};

export default PopupSuretyModel;
